import usePost from "./usePost";

function useCustomTopics() {
  const { customTopics } = usePost();

  if (!customTopics) {
    return null;
  }

  return customTopics.map(([title, slug, tag]) => {
    return {
      slug,
      title,
      tag,
    };
  });
}

export default useCustomTopics;
